module.exports = __webpack_public_path__ + "static/img/empty_data.acc147b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/empty_data.png
// module id = qIrH
// module chunks = 4